// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

export enum RequestStatusType {
    IN_PROGRESS,
    COMPLETED,
    FAILED

}
export default RequestStatusType
